import StepsImage from '@/assets/Onboarding/StepsImage.png';
import { Button } from '@/components/ui/button';
import { useQuestionnaireNavigation } from '@/context/NavigationProvider';
import { PatientPageLayout } from '@/components/PatientPageLayout';

export const MBPIntro1Page = () => {
  const { navigateNext } = useQuestionnaireNavigation();

  return (
    <PatientPageLayout
      title={
        <div className="flex flex-col items-center gap-6 mt-4">
          <img
            src={StepsImage}
            alt="Mon bilan prévention"
            className="size-40"
            width="160"
            height="160"
          />
          <p className="text-1.5xl text-center font-medium">
            Mon bilan prévention
          </p>
        </div>
      }
      footer={
        <div className="flex w-full flex-col items-center mx-auto">
          <Button variant="ctaPrimary" size="lg" onClick={navigateNext}>
            Continuer
          </Button>
        </div>
      }
    >
      <div className="flex w-full flex-col items-center gap-6 px-2 nsm:px-4">
        <p className="text-center leading-5 font-light ">
          Ce dispositif de l&apos;Assurance Maladie <br />
          remboursé à 100%{' '}
          <span className="font-medium">
            s&apos;appuie sur le <br />
            questionnaire suivant{' '}
          </span>
          pour faire le <br />
          point sur votre état de santé.
        </p>
        <div className="w-full nsm:w-[80%] border rounded-xl border-gray-200 py-3 text-center">
          <p className="text-sm font-light mb-2">
            Ce dispositif est réservé aux tranches d&apos;âge
          </p>
          <div className="grid grid-cols-2 gap-x-8 gap-y-1 font-light px-16 nsm:px-20">
            <p className="text-sm">
              <span className="font-medium">18-25</span> ans
            </p>
            <p className="text-sm">
              <span className="font-medium">45-50</span> ans
            </p>
            <p className="text-sm">
              <span className="font-medium">60-65</span> ans
            </p>
            <p className="text-sm">
              <span className="font-medium">70-75</span> ans
            </p>
          </div>
        </div>
      </div>
    </PatientPageLayout>
  );
};
